/** F&B Order status (numeric, per API spec 0-8)
 * 0 - New
 * 1 - Accepted
 * 2 - Rejected
 * 3 - No Response
 * 4 - Preparing
 * 5 - Ready To Pickup
 * 6 - On The Way
 * 7 - Completed
 * 8 - Cancelled
 */
export const FnbOrderStatus = {
  New: 0,
  Accepted: 1,
  Rejected: 2,
  NoResponse: 3,
  Preparing: 4,
  ReadyToPickup: 5,
  OnTheWay: 6,
  Completed: 7,
  Cancelled: 8,
} as const;

export type FnbOrderStatusType = (typeof FnbOrderStatus)[keyof typeof FnbOrderStatus];

/** Map FnbOrderStatus number to API orderStatus string */
export const FNB_ORDER_STATUS_TO_STRING: Record<FnbOrderStatusType, string> = {
  [FnbOrderStatus.New]: "new",
  [FnbOrderStatus.Accepted]: "accepted",
  [FnbOrderStatus.Rejected]: "rejected",
  [FnbOrderStatus.NoResponse]: "no_response",
  [FnbOrderStatus.Preparing]: "preparing",
  [FnbOrderStatus.ReadyToPickup]: "ready_to_pickup",
  [FnbOrderStatus.OnTheWay]: "on_the_way",
  [FnbOrderStatus.Completed]: "completed",
  [FnbOrderStatus.Cancelled]: "cancelled",
};
